module.exports = __webpack_public_path__ + "img/1.3fceff9c.png";